/** Agent authentication. The agent signs in before the dialer opens (RingCX-style):
 *  login → present → handle calls. The signed-in username becomes the ACD agent id,
 *  so offers route to this softphone (no hardcoded identity).
 *
 *  STUB mode (default): accepts any non-empty username/password so the flow is
 *  testable — the username is the agent id. PRODUCTION: swap `login()` for a
 *  Keycloak sign-in against the tenant realm (password grant for an embedded
 *  iframe, or a popup OIDC code flow) and carry the access token. */
export interface AuthedAgent { id: string; name: string; token?: string; }

export async function login(username: string, password: string): Promise<AuthedAgent> {
  const id = username.trim();
  if (!id || !password.trim()) throw new Error("Enter your username and password.");
  // Simulate a round-trip; production authenticates against Keycloak here.
  await new Promise((r) => setTimeout(r, 350));
  const name = id.replace(/[._-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return { id, name };
}
